import React from 'react';
import { footerConfig } from './footerConfig';
import SectionFooter from '@framework/ui/Pages/Landing/Sections/Footer';
import styles from './footer.module.scss';
import { usePathname } from '@framework/next/navigation';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';

interface IProps {
  tenant: DataroomTenant,
}

const Footer = ({ tenant }: IProps) => (
  <SectionFooter
    config={ footerConfig(tenant, usePathname()) }
    contentClassName={ styles.Content }
  />
);

export default Footer;
